import { useState } from "react";
import { HiUserCircle } from 'react-icons/hi';
import { HiArrowTopRightOnSquare, HiOutlineBookOpen } from "react-icons/hi2";
import { BsCopy } from "react-icons/bs";
import { GoMail } from "react-icons/go";


const activityData = {
  user: {
    name: "Aarav Sharma",
    email: "aarav.sharma@companydemo.in",
    progress: 75,
  },
}

export const EmailsContent = ({ userDetails, statusData }) => {

  const [data, setData] = useState(activityData);
  const { user, activities } = data;


  const activitiesData = [
    { id: 1, name: 'Karan Malhotra', desc: 'Nomination Process for HWA 2026', createddate: '7 Apr | 5:30 PM', reply: '0', status: 'Pending' },
    { id: 2, name: 'Sneha Iyer', desc: 'Interested in Participating – HWA Awards', createddate: '7 Apr | 5:30 PM', reply: '5', status: 'Completed' },
    { id: 3, name: 'Karan Malhotra', desc: 'Exploring HWA 2026 Opportunities', createddate: '7 Apr | 5:30 PM', reply: '8', status: 'Pending' },
    { id: 4, name: 'Meera Joshi', desc: 'Corporate Participation – HWA 2026', createddate: '7 Apr | 5:30 PM', reply: '2', status: 'Completed' },
    { id: 5, name: 'Vikram Nair', desc: 'Request for HWA 2026 Registration Details', createddate: '7 Apr | 5:30 PM', reply: '6', status: 'Pending' },
    { id: 6, name: 'Rohan Gupta', desc: 'Exploring HWA 2026 Opportunities', createddate: '7 Apr | 5:30 PM', reply: '4', status: 'Completed' },
    { id: 3, name: 'Karan Malhotra', desc: 'Exploring HWA 2026 Opportunities', createddate: '7 Apr | 5:30 PM', reply: '8', status: 'Pending' },
    { id: 4, name: 'Meera Joshi', desc: 'Corporate Participation – HWA 2026', createddate: '7 Apr | 5:30 PM', reply: '2', status: 'Completed' },
    { id: 5, name: 'Vikram Nair', desc: 'Request for HWA 2026 Registration Details', createddate: '7 Apr | 5:30 PM', reply: '6', status: 'Completed' },
    { id: 6, name: 'Rohan Gupta', desc: 'Exploring HWA 2026 Opportunities', createddate: '7 Apr | 5:30 PM', reply: '4', status: 'Completed' }
  ];

  let goToLink = (meetLink) => {
    window.open(meetLink, "_blank");
  };

  let handleCopy = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
  };

  return (
    <>
      <div className="p-4 md:p-6 bg-white h-screen">

        {/* Header */}
        <div className="bg-white rounded-md border border-gray-300 p-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-indigo-600 flex items-center justify-center text-white text-xl font-bold">{userDetails.initial}</div>
            <div>
              <h2 className="font-semibold text-lg">{userDetails.name}</h2>
              <p className="text-gray-500 text-sm">{userDetails.email}</p>
            </div>
          </div>
        </div>

        {/* Activities List */}
      <div className="md:pb-0 pb-16 mt-6">
          <h3 className="mb-3 font-semibold text-gray-900">Mails Status</h3>
          <div className="space-y-3">
            {activitiesData.map((activity) => {
              return (
                <div key={activity.id} className="flex xl:flex-row xl:items-center flex-col items-start xl:space-y-0 space-y-4 md:p-6 p-4 bg-white rounded-md border border-gray-300 hover:shadow-md transition-all">
                  {/* Icon & Details */}
                  <div className="flex items-center gap-5 flex-grow">
                    <GoMail size={35} className="text-gray-600" />
                    <div>
                      <div className="flex items-center gap-3 text-gray-900">
                        <span className="md:text-lg text-sm font-semibold whitespace-nowrap">{activity.name}</span>
                        <span className="text-gray-500 md:text-sm text-xs whitespace-nowrap">{activity.createddate}</span>
                      </div>
                      <h4 className="md:text-sm text-xs font-medium text-gray-900 mt-0.5">{activity.desc}</h4>
                    </div>
                  </div>

                  {/* Actions or Status */}
                  <div className="mt-5 sm:mt-0 flex gap-3 flex-shrink-0">
                    <button onClick={() => handleCopy(activity.meetingLink)} className="flex items-center justify-center gap-2 w-44 py-2.5 border border-gray-300 text-gray-900 rounded-md font-medium transition-colors md:text-base text-sm">
                      <span>{activity.reply}</span>
                      <span>Replies</span>
                    </button>

                    <div className="flex items-center gap-3">
                      <span
                        className={`w-44 text-center mx-auto py-2.5 rounded-md md:text-base text-sm font-medium ${activity.status === "Completed"
                          ? "bg-green-500 text-white"
                          : "bg-yellow-500 text-white"
                          }`}
                      >
                        {activity.status}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

      </div>

    </>
  );
};